import Request from 'shared/api/Request';

// TODO: use constant
export default applicationId => Request.get(`/applications/${applicationId}/assignees`);
